/**
 * SidePanel — 인라인 사이드 패널 래퍼.
 *
 * w-64 aside + 선택적 h-14 헤더 + 스크롤 가능 콘텐츠 영역.
 * md+ 에서만 표시 (모바일은 Sheet 또는 TabBar로 대체).
 */
import { cn } from "@/shared/lib/utils";

export interface SidePanelProps {
  /** 패널 헤더 제목 */
  title: string;
  /** 제목 좌측 아이콘 */
  icon?: React.ReactNode;
  /** 스크롤 가능 콘텐츠 */
  children: React.ReactNode;
  /** true면 내장 헤더 생략 (ConversationHistory처럼 자체 헤더가 있는 경우) */
  headless?: boolean;
  className?: string;
}

export function SidePanel({
  title,
  icon,
  children,
  headless = false,
  className,
}: SidePanelProps) {
  return (
    <aside
      className={cn(
        "hidden md:flex w-64 shrink-0 flex-col border-r border-stroke-subtle bg-surface-raised",
        className,
      )}
    >
      {!headless && (
        <div className="flex h-14 shrink-0 items-center gap-2 border-b border-stroke-subtle px-4">
          {icon && (
            <span className="flex size-5 items-center justify-center text-text-brand">
              {icon}
            </span>
          )}
          <span className="text-[13px] font-semibold text-text-primary">
            {title}
          </span>
        </div>
      )}
      <div className="flex-1 overflow-hidden">{children}</div>
    </aside>
  );
}
